export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7638.c8ea2b12.jpg";